<template>
  <div class="contents" :style="style">
    <slot />
  </div>
</template>

<script lang="ts" setup>
import {
  brandThemeKey,
  brandThemeStyle,
  resolveBrandThemeName,
} from '~/themes/brandThemes';

const props = defineProps({
  theme: { type: String, default: undefined },
});

const name = computed(() => resolveBrandThemeName(props.theme));
const style = computed(() => brandThemeStyle(name.value));

provide(brandThemeKey, name);
</script>
